import { useEffect, useState } from 'react';
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from '../one_time_paiement/CheckoutForm';
import { getSentence } from '../../translations';
import { Topbar } from '../../Topbar';

function Subscribe (props)
{
  const { stripePromise } = props;
  const [ clientSecret, setClientSecret ] = useState('');
  const paiementType = window.location.pathname.split('/')[2];
  const available_paiement_type = {"10_monthly": 15, "50_monthly": 55, "120_monthly": 120}
  const price = available_paiement_type[paiementType];


useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    fetch("/create-payment-intent/" + String(paiementType))
      .then(async (res) => {
        try {
          if (!res.ok) {
            console.error('Failed to create payment intent:', res.status, res.statusText);
            return null;
          }
          
          const text = await res.text();
          if (!text) {
            console.error('Empty response from create-payment-intent');
            return null;
          }
          
          try {
            return JSON.parse(text);
          } catch (parseError) {
            console.error('Failed to parse JSON from create-payment-intent:', parseError, 'Response was:', text);
            return null;
          }
        } catch (error) {
          console.error('Error processing payment intent response:', error);
          return null;
        }
      })
      .then((data) => {
        if (data && data.clientSecret) {
          setClientSecret(data.clientSecret);
          console.log(data.clientSecret)
          console.log("------------")
          console.log(data)
        } else {
          console.error('No clientSecret in payment intent response');
        }
      })
      .catch(error => {
        console.error('Failed to fetch payment intent:', error);
      });
  }, [paiementType]);

  

  return (
   <div style={{ height: "100vh"}} >
              
        <Topbar />
        <p style={{textAlign: "center"}} >{getSentence(188)} {price}€{getSentence(189)} </p>
        <br />
  
        <div style={{display: "block", 
          marginLeft: "auto",
          marginRight: "auto",
          maxWidth:"800px"}}>
          {clientSecret && stripePromise && (
            <Elements stripe={stripePromise} options={{ clientSecret, }}>
              <CheckoutForm />
            </Elements>
          )}
        </div>
    </div>
    );
};

export default Subscribe;